import { SetStateAction, useEffect, Dispatch } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import WORDING from 'constants/wording'
import { useNavigate } from 'react-router-dom'
import { FireMembership } from 'assets/icons'
import { MEMBERSHIP_PRICE } from 'config'
import RoundedIcon from './RoundedIcon'
import { MembershipCard } from './MembershipCard'
import ModalContainer from './ModalContainer'
import PrimaryButton from './primaryButton'
import SuspendedMembership from './SuspendedMembership'

const { SUSPENDED_MEMBERSHIP } = WORDING

interface MembershipSubscriptionModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  titleSection?: string | JSX.Element
  primaryButtonFunction: () => void
}

export const MembershipSubscriptionModal = ({
  isOpen,
  setIsOpen,
  titleSection,
  primaryButtonFunction
}: MembershipSubscriptionModalProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      trackEvent({
        eventName: 'bille_wayniplus_popup_suscripcion'
      })
    }
  }, [isOpen])

  return (
    <ModalContainer isShown={isOpen} setModalFunction={setIsOpen}>
      <MembershipCard
        twoCols={false}
        titleSection={titleSection}
        primarybuttonFunc={primaryButtonFunction}
        textButtonFunc={() => {
          trackEvent({
            eventName: 'bille_wayniplus_popup_ver_beneficios'
          })
          navigate('/suscripcion')
        }}
      />
    </ModalContainer>
  )
}

export const MembershipSubscriptionConfirmModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  handleSubscription
}) => (
  <ModalContainer isShown={isOpen} setModalFunction={setIsOpen}>
    <div className='flex flex-col justify-center items-center text-black py-6'>
      <RoundedIcon
        className='!h-10 !w-10 mb-2'
        icon={<FireMembership className='w-5 h-5' />}
      />
      <h3 className='text-2xl text-center font-bold'>
        Detalles de tu membresía
      </h3>
      <div className='px-1 flex w-full mt-5 justify-between text-blue-900 font-bold py-2'>
        <span>Monto de suscripción:</span> <span>$ {MEMBERSHIP_PRICE}</span>
      </div>
      <p className='text-xs text-left w-full font-medium border-t border-b py-2'>
        Comenzá a pagar a partir del 01 del próximo mes
      </p>
      <div className='flex justify-between w-full mt-5'>
        <PrimaryButton
          buttonText='Cancelar'
          outlined
          className='max-w-[8rem]'
          primaryButtonFunction={() => {
            setIsOpen(false)
            trackEvent({
              eventName: 'bille_wayniplus_popup_membresia_cancelar'
            })
          }}
        />
        <PrimaryButton
          buttonText='Confirmar'
          className='max-w-[8rem]'
          isLoading={isLoading}
          primaryButtonFunction={() => {
            handleSubscription()
            trackEvent({
              eventName: 'bille_wayniplus_popup_membresia_confirmar'
            })
          }}
        />
      </div>
    </div>
  </ModalContainer>
)

export const SuspendedMembershipModal = ({
  isModalOpen,
  setIsModalOpen,
  description = SUSPENDED_MEMBERSHIP
}: {
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
  description?: string | JSX.Element
}) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_popup_membresia_suspendida' })
  }, [])

  return (
    <ModalContainer
      isShown={isModalOpen}
      setModalFunction={setIsModalOpen}
      className='rounded-[10px] max-w-[22rem] border border-red-900'
      noCloseButton
    >
      <SuspendedMembership
        isModal
        cancelButtonAction={() => setIsModalOpen(false)}
        paragraphText={description}
        eventName='bille_boton_pagar_popup_membresia_suspendida'
      />
    </ModalContainer>
  )
}
